import BaseEnumType from "../../common/base-enum-type";

const SetType = Object.freeze({
    Sets: new BaseEnumType("sets", "Sets"),
    TiebreakSets: new BaseEnumType("tiebreakSets", "Tiebreak Sets")
});

export default SetType;
